import { LAYOUT_LIST, TEXT } from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { useEditorStore } from '~/shell/Store';

export const Statement6: Translator = sequence => {
  let isEditor = false;
  try {
    const { editorMode } = useEditorStore.getState();
    isEditor = !!editorMode;
  } catch (e) {
    // ignore if store not available
  }

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(
              {
                ...item,
                title: '',
                subtitle: '',
                body: ''
              } as ItemOfType<'Card'>,
              {
                width: '80vw',
                height: 'auto',
                padding: { _: '0px', md: '80px' },
                extraItems: [
                  {
                    id: `${item.id}_subtitle`,
                    type: TEXT,
                    values: {
                      value: item.subtitle,
                      variant: 'sub_heading'
                    },
                    items: []
                  },
                  {
                    id: `${item.id}_title`,
                    type: TEXT,
                    values: {
                      value: item.title,
                      variant: 'heading2',
                      typing: !isEditor
                    },
                    items: []
                  },
                  {
                    id: `${item.id}_body`,
                    type: TEXT,
                    values: {
                      value: item.body
                    },
                    items: []
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });
};
